export enum TypeOfDateSettingsEnumCharts {
  'FIXED_DATE' = 'FIXED_DATE',
  'REALTIME' = 'REALTIME'
}
